import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "!m-0 flex justify-center gap-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex items-center justify-end py-2" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { class: "!m-0 flex gap-4 justify-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex items-center justify-end" }
const _hoisted_11 = { class: "text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      (
          _ctx.denounceType === _ctx.$t('labels.generic', { pt: 'Tópicos', en: 'Topics' })
        )
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            value: _ctx.topicsDenouncesList,
            showGridlines: "",
            class: "custom-datatableForum !shadow-md rounded-md mb-16"
          }, _createSlots({
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "topic.title",
                header: _ctx.$t('forum.listDenounces.topics.table.columns.title'),
                class: "sm:w-[37vw] sm:max-w-[37vw] md:w-[25vw] md:max-w-[25vw] truncate",
                headerClass: "!bg-h-primary-500  "
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 
            _ctx.$t('forum.listDenounces.topics.table.columns.author')
          ,
                class: "sm:max-w-[292px] sm:w-[15vw] truncate",
                field: "topic.userAuthor.name",
                headerClass: "!bg-h-primary-500"
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 
            _ctx.$t('forum.listDenounces.topics.table.columns.denounces')
          ,
                field: "denounces",
                class: "table-style !max-w-32 w-28",
                headerClass: "!bg-h-primary-500"
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.denounces?.length), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 
            _ctx.$t('forum.listDenounces.topics.table.columns.status')
          ,
                class: "table-style w-[12vw]",
                headerClass: "!bg-h-primary-500"
              }, {
                body: _withCtx(() => [
                  _createElementVNode("p", {
                    class: _normalizeClass([[_ctx.labelDenouncesStyle[_ctx.statusOfDenounce?.value]], "px-1 text-sm rounded-2xl"])
                  }, _toDisplayString(_ctx.statusOfDenounce?.label), 3)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                headerClass: "!bg-h-primary-500 w-[8vw] max-w-[120px]",
                class: "!p-0"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_2, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      onClick: ($event: any) => (_ctx.showDenounces(data)),
                      class: "p-[11px] my-4"
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "md-listalt-round",
                        width: "18",
                        height: "18"
                      })
                    ], 8, _hoisted_3)), [
                      [
                        _directive_tooltip,
                        
                  _ctx.$t('labels.generic', {
                    pt: 'Ver denúncias',
                    en: 'See denounces',
                  })
                ,
                        void 0,
                        { top: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      class: "p-[11px] my-4",
                      onClick: ($event: any) => (_ctx.sendDisplayedItem(data))
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "md-search-sharp",
                        width: "18",
                        height: "18"
                      })
                    ], 8, _hoisted_4)), [
                      [
                        _directive_tooltip,
                        
                  _ctx.$t('labels.generic', { pt: 'Ver tópico', en: 'See topic' })
                ,
                        void 0,
                        { top: true }
                      ]
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            (_ctx.total > _ctx.size)
              ? {
                  name: "footer",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Paginator, {
                        rows: _ctx.size,
                        totalRecords: _ctx.total,
                        first: _ctx.getFirstItemIndexActualPage(),
                        value: _ctx.topicsDenouncesList,
                        onPage: _ctx.onPaginate,
                        class: "md:w-full w-fit md:flex md:right-0 md:justify-end",
                        pageLinkSize: 3
                      }, {
                        start: _withCtx(() => [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatePaginatorText()), 1)
                        ]),
                        _: 1
                      }, 8, ["rows", "totalRecords", "first", "value", "onPage"])
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["value"]))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            value: _ctx.commentsDenouncesList,
            class: "custom-datatableForum mb-16 !shadow-md rounded-md",
            showGridlines: ""
          }, _createSlots({
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: 
            _ctx.$t('forum.listDenounces.comments.table.columns.author')
          ,
                field: "comment.userAuthor.name",
                class: "max-w-[930px] w-[70vw]",
                headerClass: "!bg-h-primary-500"
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 
            _ctx.$t('forum.listDenounces.comments.table.columns.denounces')
          ,
                field: "denounces",
                class: "table-style w-[10vw] max-w-36",
                headerClass: "!bg-h-primary-500"
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.denounces.length), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 
            _ctx.$t('forum.listDenounces.comments.table.columns.status')
          ,
                class: "table-style w-[12vw]",
                headerClass: "!bg-h-primary-500 "
              }, {
                body: _withCtx(() => [
                  _createElementVNode("p", {
                    class: _normalizeClass([[_ctx.labelDenouncesStyle[_ctx.statusOfDenounce?.value]], "px-1 text-sm rounded-2xl"])
                  }, _toDisplayString(_ctx.statusOfDenounce?.label), 3)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                headerClass: "!bg-h-primary-500 w-[8vw] max-w-[120px]",
                class: "!p-0"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_7, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      class: "p-[11px] my-4",
                      onClick: ($event: any) => (_ctx.showDenounces(data))
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "md-listalt-round",
                        width: "18",
                        height: "18"
                      })
                    ], 8, _hoisted_8)), [
                      [
                        _directive_tooltip,
                        
                  _ctx.$t('labels.generic', {
                    pt: 'Ver denúncias',
                    en: 'See denounces',
                  })
                ,
                        void 0,
                        { top: true }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      class: "p-[11px] my-4",
                      onClick: ($event: any) => (_ctx.sendDisplayedItem(data))
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "md-search-sharp",
                        width: "18",
                        height: "18"
                      })
                    ], 8, _hoisted_9)), [
                      [
                        _directive_tooltip,
                        
                  _ctx.$t('labels.generic', {
                    pt: 'Ver comentário',
                    en: 'See comment',
                  })
                ,
                        void 0,
                        { top: true }
                      ]
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            (_ctx.total > _ctx.size)
              ? {
                  name: "footer",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Paginator, {
                        rows: _ctx.size,
                        totalRecords: _ctx.total,
                        value: _ctx.commentsDenouncesList,
                        onPage: _ctx.onPaginate,
                        first: _ctx.getFirstItemIndexActualPage(),
                        pageLinkSize: 3,
                        class: "md:w-full w-fit md:flex md:right-0 md:justify-end"
                      }, {
                        start: _withCtx(() => [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatePaginatorText()), 1)
                        ]),
                        _: 1
                      }, 8, ["rows", "totalRecords", "value", "onPage", "first"])
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["value"]))
    ])
  ]))
}